// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { Button, Label, Input } from "@revvsales/components";

// Components Imports

class ConfirmationBox extends Component {
  state = {
    confirm: false,
  };

  _toggleCheckbox = () => {
    this.setState(prevState => ({ confirm: !prevState.confirm }));
  };

  _onClose = () => {
    this.setState({ confirm: false });
    this.props.closePopup();
  };

  _onConfirmation = data => {
    const { confirmAction, closePopup } = this.props;
    this.setState({ confirm: false });
    confirmAction(data);
    closePopup();
  };

  render() {
    const {
      show,
      header,
      subHeader,
      checkboxLabel,
      data,
      cancelBtnText,
      okBtnText,
      name,
      disableCheckbox,
      confirmationBoxRef,
      closeOnOverlayClick,
    } = this.props;
    return (
      <Modal
        open={show}
        onClose={this._onClose}
        center
        closeOnOverlayClick={closeOnOverlayClick}>
        <div
          className="confirmation-popup"
          data-test="confirmationbox-confirmation-popup"
          ref={confirmationBoxRef}>
          <div
            className="quotedelete-title"
            data-test="confirmationbox-template-delete-title">
            {header}
          </div>
          <div
            className="quotedelete-description"
            data-test="confirmationbox-template-delete-description">
            {subHeader}
          </div>
          {disableCheckbox ? null : (
            <div
              className="quotedelete-checkbox"
              data-test="confirmationbox-template-delete-checkbox">
              <Input
                id="documentdelete-checkbox"
                data-test="confirmationbox-template-delete-checkbox-input"
                type="checkbox"
                value=""
                checked={this.state.confirm}
                onChange={() => this._toggleCheckbox()}
              />
              <Label
                htmlFor="documentdelete-checkbox"
                data-test="documentdelete-checkbox-label">
                <span
                  className="delete-checkbox-label"
                  data-test="confirmationbox-template-delete-checkbox-label">
                  {checkboxLabel}
                </span>
              </Label>
            </div>
          )}

          <div className="quote-footer">
            <div className="quote-popup-response">
              <Button
                className="btn btn-transparent createquotepopup-footer-cancelbtn"
                data-test="confirmationbox-no-i-do-not-want-template-delete-cancel-button"
                id={`${name}-confirm-cancel-btn`}
                onClick={this._onClose}>
                {cancelBtnText || "No, I do not want to"}
              </Button>
              <Button
                className="btn reject-document"
                data-test="confirmationbox-template-delete-button"
                id={`${name}-confirm-ok-btn`}
                disabled={disableCheckbox ? false : !this.state.confirm}
                onClick={() => this._onConfirmation(data)}>
                {okBtnText || "Confirm"}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

ConfirmationBox.defaultProps = {
  closeOnOverlayClick: false,
};

export default ConfirmationBox;



// WEBPACK FOOTER //
// ./src/commonComponents/ConfirmationBox/ConfirmationBox.js